import { queryMyProfile } from "@/apis"
import { taskCheckInStatus } from "@/apis/task"
import { makeAutoObservable, runInAction } from "mobx"

export class UserStore {
  uid: string = ''
  nickname: string = ''
  userName: string = ''
  phoneNumber: string = ''
  email: string = ''
  vipLevel: number = 0
  vipExpiresAt: number = 0
  createTime: string = ''
  password: string = ''
  points: number = 0
  // quota: {
  //   folder?: number
  //   file?: number
  // } = { file: 0, folder: 0 }
  avatar?: string = ''
  isCheckedIn: boolean = false
  loading: boolean = false

  permission: {
    tplPublish?: boolean
    allowSaveToCloud?: boolean
  } = {}

  rootStore

  constructor(rootStore) {
    makeAutoObservable(this, {
      rootStore: false
    })
    this.rootStore = rootStore
  }

  get isValidUser() {
    return !!this.phoneNumber || !!this.email || !!this.userName || !!this.uid
  }

  async queryUserInfo(force: boolean = false) {
    // 如果已经有用户信息了，就不需要再查询了
    if (this.isValidUser && !force) {
      return
    }
    this.loading = true
    try {
      const res = await queryMyProfile()
      const { code, data = {} } = res
      this.nickname = data.nickname
      this.avatar = data.avatar
      this.phoneNumber = data.phoneNumber
      this.userName = data.userName
      this.email = data.email
      this.vipLevel = data.vipLevel
      this.vipExpiresAt = data.vipExpiresAt || 0
      // this.quota = data.quota
      this.uid = data.id
      this.createTime = data.createTime
      this.permission = data.permission
      this.password = data.password || ''
      this.points = data.points || 0
      this.checkInStatus()
    } catch (error) {

    } finally {
      this.loading = false
    }
  }
  async checkInStatus() {
    try {
      this.loading = true
      const res = await taskCheckInStatus()
      if (res.code === 0) {
        this.isCheckedIn = res.data.isOver
      }
    } catch (error) {
    } finally {
      this.loading = false
    }
  }
  setIsCheckedIn(isCheckedIn: boolean) {
    runInAction(() => {
      this.isCheckedIn = isCheckedIn
    })
  }

  hasPassword() {
    return !!this.password
  }
  setPassword(password: string) {
    runInAction(() => {
      this.password = password
    })
  }

  subtractPoints(points: number) {
    runInAction(() => {
      this.points -= points
    })
  }

  addPoints(points: number) {
    runInAction(() => {
      this.points += points
    })
  }

  setNickname(nickname: string) {
    runInAction(() => {
      this.nickname = nickname
    })
  }
}